export const REMOVE_SPECIAL_CHAR_FROM_STRING = /[^a-zA-Z0-9]/g;
export const EMAIL_REGEX = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const PHONE_REGEX = /^\+971(5[0-9])(\d{3})(\d{4})$/;
export const NUMBERS_ONLY_REGEX = /^(?:0|[1-9]\d*)(?:\.\d+)?$/;
export const REMOVE_SPACE_FROM_STRING = /\s+/g;
export const REMOVE_NON_DIGITS_FROM_STRING = /[^0-9]/g;
export const NUMBERS_ONLY_WITH_PLUS_SIGN_REGEX = /^[0-9+]*$/;

/** Password validation: at least one uppercase letter */
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
/** Password validation: at least one digit */
export const PASSWORD_DIGIT_REGEX = /\d/;
/** Password validation: at least one special character */
export const PASSWORD_SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>]/;
